<template>
    <div>
        <div class="x-stat">
            <a-row>
                <a-col :span="3">
                    <a-statistic title="数量" :value="totalRow" />
                </a-col>
            </a-row>
        </div>

        <a-card :bordered="false">
            <div class="x-filter">
                <a-form layout="inline">
                    <a-row :gutter="24">
                        <a-col :span="4">
                            <a-form-item label="单页名称">
                                <a-input v-model="queryParams.name" placeholder=""/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-item label="标识">
                                <a-input v-model="queryParams.ident" placeholder=""/>
                            </a-form-item>
                        </a-col>
                        <template v-if="advanced">
                            <a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
                        </template>
                        <a-col :span="!advanced && 4 || 24">
                            <span class="x-filter-submit-box" :style="advanced && {float:'right', overflow:'hidden'} || {}">
                                <a-button type="primary" @click="fetchTableData">查询</a-button>
                                <a-button style="margin-left:8px" @click="() => this.queryParams={}">重置</a-button>
                                <a @click="toggleAdvanced" style="margin-left: 8px">
                                    {{ advanced ? '收起' : '展开' }}
                                    <a-icon :type="advanced ? 'up' : 'down'"/>
                                </a>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <div class="x-tool">
                <a-button type="primary" icon="plus" @click="add" v-has="'/content/pageAdd'">新增</a-button>
            </div>

            <a-table
                :rowKey="record => record.id"
                :columns="tableColumns"
                :loading="tableLoading"
                :dataSource="tableData"
                :pagination="false"
            >
                <template slot="action" slot-scope="record">
                    <a @click="update(record)" v-has="'/content/pageUpdate'">修改</a>
                </template>
            </a-table>

            <div class="x-pagination">
                <a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
                  :hideOnSinglePage="true" show-less-items />
            </div>

            <page-form-modal
                ref="pageFormModal"
                :visible="pageFormModalVisible"
                :loading="pageFormModalLoading"
                @cancel="pageFormModalCancel"
                @ok="pageFormModalOk"
            />

        </a-card>
    </div>
</template>

<script>
import PageFormModal from './PageFormModal.vue';
import { pageList, pageAdd, pageUpdate } from "@/api/content/page.js";
import moment from 'moment';

const tableColumns = [
    {
        title: '#',
        dataIndex: 'id'
    },
    {
        title: '单页名称',
        dataIndex: 'name'
    },
    {
        title: '标识',
        dataIndex: 'ident'
    },
    {
        title: '创建时间',
        dataIndex: 'created'
    },
    {
        title: '操作',
        scopedSlots: { customRender: 'action' }
    }
];

export default {
    components: {
        PageFormModal
    },
    data() {
        return {
            advanced: false,
            queryParams: {},
            tableLoading: false,
            tableColumns,
            tableData: [],
            totalRow: 0,
            pageSize: 20,
            pageIndex: 1,
            pageFormModalVisible: false,
            pageFormModalLoading: false,
            createTime:[]
        }
    },
    created() {
        this.fetchTableData();
    },
    methods: {
        fetchTableData() {
            this.tableLoading = true;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.page = this.pageIndex;
            return pageList(this.queryParams).then(res => {
                if (res && res.data) {
                    this.tableData = res.data.recordList || [];
                    this.totalRow = res.data.totalRow || 0;
                } else {
                    this.tableData = [];
                    this.totalRow = 0;
                }
                this.tableLoading = false;
            }).catch(error => {
                console.error('获取列表失败:', error);
                this.$message.error('获取列表失败，请稍后重试');
                this.tableLoading = false;
            });
        },
        toggleAdvanced() {
            this.advanced = !this.advanced;
        },
        pageChange(current) {
            this.pageIndex = current;
            this.fetchTableData();
        },
        add() {
            this.$refs.pageFormModal.initForm();
            this.pageFormModalVisible = true;
        },
        update(record) {
            this.pageFormModalVisible = true;
            // 确保数据完整，使用 $nextTick 确保弹窗打开后再设置数据
            this.$nextTick(() => {
                this.$refs.pageFormModal.form = {
                    id: record.id || 0,
                    name: record.name || '',
                    ident: record.ident || '',
                    content: record.content || ''
                };
            });
        },
        pageFormModalOk() {
            this.$refs.pageFormModal.$refs['adminForm'].validate(valid => {
                if (valid) {
                    this.pageFormModalLoading = true;
                    const formData = this.$refs.pageFormModal.form;
                    
                    // 确保数据完整性
                    const submitData = {
                        id: formData.id || 0,
                        name: formData.name || '',
                        ident: formData.ident || '',
                        content: formData.content || ''
                    };
                    
                    const promise = submitData.id > 0 
                        ? pageUpdate(submitData) 
                        : pageAdd(submitData);
                    
                    promise.then(res => {
                        if (res && res.isSucceed !== false) {
                            const message = submitData.id > 0 ? '修改单页成功' : '新增单页成功';
                            this.pageFormAfter(message);
                        } else {
                            this.$message.error(res?.message || '操作失败');
                            this.pageFormModalLoading = false;
                        }
                    }).catch(error => {
                        console.error('操作失败:', error);
                        this.$message.error(error?.message || '操作失败，请稍后重试');
                        this.pageFormModalLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        pageFormModalCancel() {
            this.pageFormModalVisible = false;
        },
        pageFormAfter(message) {
            this.pageFormModalVisible = false;
            this.pageFormModalLoading = false;
            this.fetchTableData();
            this.$message.success(message);
        },
        onCreateTime(values) {
            this.queryParams.startCreateTime = moment(values[0]).unix();
            this.queryParams.endCreateTime = moment(values[1]).unix();
        }
  }
}
</script>

<style scoped>
	.qrcode-box {
		.qrcode {
			display: flex;
			margin: auto;
		}
	}
</style>